import { Box, Paper, Typography, Button } from "@mui/material";
import { useAppSelector } from "shared/lib/hooks/hooks";
import word from "assets/images/marathon/word.svg";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { serverURL } from "shared/lib/serverURL";

const Documents = () => {
  const { t } = useTranslation();

  const marathon = useAppSelector(
    (state) => state.marathons.marathonsById.response.data
  );

  const marathonInfo = marathon;

  const handleDocumentDownload = async (documentUrl: any) => {
    const documentUrlCopy = { ...documentUrl };

    const documentName = documentUrlCopy.document.slice(59);
    const documentExtension =
      documentUrlCopy.document.split(".")[
      documentUrlCopy.document.split(".").length - 1
      ];
    const response = await axios.get(`${serverURL}${documentUrl.document}`, {
      responseType: "blob",
    });
    const href = URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", `${documentName}.${documentExtension}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  };

  return (
    <Paper
      sx={{
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "none",
      }}
    >
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          color: "#0090D1",
          paddingBottom: "20px",
        }}
      >
        {t("myMarathon.documents")}
      </Typography>

      {!marathonInfo?.documents?.length && (
        <Typography sx={{ color: "#6B7280" }}>{t("documents.noDocument")}</Typography>
      )}

      {marathonInfo?.documents?.map((document: any, index: number) => {
        const fileName = document.document.slice(59);

        return (
          <Box
            key={index}
            sx={{
              marginBottom: "24px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              onClick={() => handleDocumentDownload(document)}
              sx={{
                width: "249px",
                height: "104px",
                borderRadius: "8px",
                border: "1px solid #EEEEEE",
                backgroundColor: "#FFFFFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "0.2s",
                boxSizing: "border-box",

                "&:hover": {
                  backgroundColor: "#F7F9FA",
                },
              }}
            >
              <img
                src={word}
                alt="document"
                style={{
                  width: "48px",
                  height: "48px",
                  objectFit: "contain",
                }}
              />
            </Box>

            <Typography
              sx={{
                marginTop: "8px",
                fontSize: "14px",
                color: "#3E444A",
                maxWidth: "249px",
              }}
            >
              {fileName}
            </Typography>

            <Button
              onClick={() => handleDocumentDownload(document)}
              variant="outlined"
              // startIcon={<DownloadIcon />}
              sx={{
                marginTop: "8px",
                width: "207px",
                borderRadius: "12px",
                textTransform: "none",
                fontSize: "14px",
                paddingLeft: "12px",
                paddingRight: "12px",
                whiteSpace: "normal",
                lineHeight: 1.2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <span style={{ flexGrow: 1, textAlign: "center" }}>
                {t("myMarathon.downloadAllDocs")}
              </span>
            </Button>

          </Box>
        );
      })}
    </Paper>
  );
};

export default Documents;
